import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { FormattedMessage } from 'react-intl'
import { setQuestSection } from '../actions/quest'
import { createActivity } from '../actions/activity'
import { name, cancel } from '../utils/messages'

class ActivityAddContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      name: ''
    }
    this.handleNameChangeBound = this.handleNameChange.bind(this)
    this.onCancelClickBound = this.onCancelClick.bind(this)
    this.onCreateActivityClickBound = this.onCreateActivityClick.bind(this)
  }
  render() {
    const { isLoading } = this.props
    return (
      <div className="row activityadd">
        <div className="form-group">
          <label className="control-label left" htmlFor="activity_name">
            {name}
          </label>
          <div className="right">
            <input
              className="form-control"
              id="activity_name"
              name="activity_name"
              type="text"
              onChange={this.handleNameChangeBound}
            />
          </div>
        </div>
        <div className="form-group">
          <label className="control-label left" htmlFor="activity_name">
            &nbsp;
          </label>
          <div className="right">
            {!isLoading && (
              <div>
                <div
                  className="button add btn-primary"
                  onClick={this.onCreateActivityClickBound}
                >
                  <FormattedMessage
                    id={'ActivityAdd.CreateActivity'}
                    defaultMessage={'Create Activity'}
                  />
                </div>
                <div
                  className="button canceladd btn-secondary"
                  onClick={this.onCancelClickBound}
                >
                  {cancel}
                </div>
              </div>
            )}
            {isLoading && <div className="loading" />}
          </div>
        </div>
      </div>
    )
  }

  handleNameChange(e) {
    this.setState({ name: e.target.value })
  }

  onCancelClick() {
    const { dispatch, quest, activityId } = this.props
    dispatch(setQuestSection('activities', activityId))
    dispatch(push(`/quest/${quest.id}/activities/${activityId}`))
  }

  onCreateActivityClick() {
    const { dispatch, quest } = this.props
    dispatch(createActivity(quest.id, this.state.name))
  }
}

ActivityAddContainer.propTypes = {
  quest: PropTypes.object,
  activityId: PropTypes.number,
  dispatch: PropTypes.func,
  isLoading: PropTypes.bool.isRequired
}

export const mapStateToProps = state => ({
  quest: state.quest.item,
  activityId: state.quest.activityId,
  isLoading: state.quest.isFetching
})

export default connect(mapStateToProps)(ActivityAddContainer)
export { ActivityAddContainer as ActivityAddContainerDisconnected }



// WEBPACK FOOTER //
// ./src/containers/ActivityAdd.js